import * as React from 'react'
import { TranslateFunction } from '@ds/base'

export const defaultTranslate = (textId: string) => textId

export const TranslationContext: React.Context<TranslateFunction> =
  React.createContext(defaultTranslate)

interface ProviderProps {
  translate: TranslateFunction
}

export const TranslationProvider: React.FunctionComponent<ProviderProps> = (
  props
) => {
  return (
    <TranslationContext.Provider value={props.translate || defaultTranslate}>
      {props.children}
    </TranslationContext.Provider>
  )
}

export function withTranslate<P extends { translate: TranslateFunction }>(
  Component: React.ComponentType<P>
) {
  return function ComponentWithTranslation(
    props: Pick<P, Exclude<keyof P, 'translate'>>
  ) {
    return (
      <TranslationContext.Consumer>
        {(translate) => <Component {...(props as P)} translate={translate} />}
      </TranslationContext.Consumer>
    )
  }
}
